import { useCallback, useEffect, useState } from "react";
import { toast } from "sonner";
import api, { errMsg } from "@/lib/api";

export default function useLoad(url, params) {
  const [data, setData] = useState(null);
  const key = JSON.stringify(params || {});
  const reload = useCallback(async () => {
    if (!url) return;
    try {
      const { data: d } = await api.get(url, { params: JSON.parse(key) });
      setData(d);
    } catch (e) {
      toast.error(errMsg(e));
      setData((prev) => prev ?? null);
    }
  }, [url, key]);
  useEffect(() => { reload(); }, [reload]);
  return [data, reload, setData];
}
